import AbstractFilter from './abstract-filter'

const moduleIndustries = new AbstractFilter()

moduleIndustries.configuration.api.read = 'news-industries'

export default {
  namespaced: true,
  state: moduleIndustries.state,
  mutations: moduleIndustries.mutations,
  actions: moduleIndustries.actions
}
